import { render } from "./despesas-list.vue?vue&type=template&id=70316af4"
import script from "./despesas-list.vue?vue&type=script&lang=js"
export * from "./despesas-list.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__